import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
let UserStore = class UserStore extends VuexModule {
    users = [];
    confirmUserData = [];
    companyName = '';
    USERS_DATA(data) {
        this.users = data;
    }
    CONFIRM_USER_DATA(data) {
        this.confirmUserData = data;
    }
    COMPANY_NAME(data) {
        this.companyName = data;
    }
};
__decorate([
    Mutation
], UserStore.prototype, "USERS_DATA", null);
__decorate([
    Mutation
], UserStore.prototype, "CONFIRM_USER_DATA", null);
__decorate([
    Mutation
], UserStore.prototype, "COMPANY_NAME", null);
UserStore = __decorate([
    Module({
        namespaced: true,
    })
], UserStore);
export { UserStore };
export default UserStore;
